<template>
  <div class="main">
    <div class="content_wrapper">
      <slot name="main"></slot>
    </div>
    <div class="seperator-h"></div>
    <div class="extends_wrapper">
      <slot name="aside">
        <div class="blank"></div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentLayout",
};
</script>

<style scoped>
.main {
  position: relative;
  height: 100%;
  padding: 1em;
}

.content_wrapper {
  height: 100%;
  overflow: auto;
  position: relative;
}

.seperator-h {
  display: none;
}

.extends_wrapper {
  display: none;
}

.blank {
  background: #f3f3f3;
  border-radius: 1em;
  width: 100%;
  height: 100%;
}

@media (min-width: 2900px) {
  .main {
    display: grid;
    grid-template-columns: 8fr auto 2fr;
  }

  .content_wrapper {
    grid-column: 1;
  }

  .extends_wrapper {
    display: block;
    grid-column: 3;
    padding: 1em;
  }

  .seperator-h {
    display: block;
    grid-column: 2;
    height: 100%;
    width: 3px;
    margin: 0 2em;
    background: var(--border);
    border: none;
  }
}
</style>
